export class LogSourceLocationCloudTrail {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "prefix",
            "baseName": "prefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountId",
            "baseName": "accountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return LogSourceLocationCloudTrail.attributeTypeMap;
    }
    constructor() {
    }
}
